<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { Planungsgeschaeft } from '@/models/Planungsgeschaeft';
import { Mailbox, MailboxCollection } from '@/models/Mailbox';
import { useCollection, type UseCollectionOptions } from '@/composables/useDataTableProps';
import KtgTable from '@kp/geofy-vuejs-lib/tg-system/components/KpTable.vue';
import type { KtgTableHeaderProps } from '@kp/geofy-vuejs-lib/tg-system/components/KpTableTypes.js';
import { getI18n } from '@/helpers/i18n';
import { apiUrl } from '@/helpers/api';

const props = defineProps<{
    geschaeft: Planungsgeschaeft;
}>();

const ech = new MailboxCollection();

const { models, tableSort, pageSize } = useCollection(ech, {
    autoload: false,
    collectionsFilter: [
        {
            property: 'planning_permission_application_id',
            value: props.geschaeft.id
        }
    ]
} as UseCollectionOptions);

const tableHeaders = ref<KtgTableHeaderProps[]>([
    {
        title: getI18n().t('dir'),
        dataProperty: 'direction',
        sortable: true
    },
    {
        title: getI18n().t('sender'),
        dataProperty: 'sender_id',
        sortable: true
    },
    {
        title: getI18n().t('empfaenger'),
        dataProperty: 'recipient_display',
        sortable: true
    },
    {
        title: getI18n().t('event'),
        dataProperty: 'event',
        sortable: true
    },
    {
        title: getI18n().t('event_type'),
        dataProperty: 'event_type',
        sortable: true
    },
    {
        title: getI18n().t('message_type'),
        dataProperty: 'ech_message_type',
        sortable: true
    },
    {
        title: getI18n().t('created'),
        dataProperty: 'created',
        sortable: true
    },
    {
        dataProperty: 'myactions',
        sortable: false
    }
]);

onMounted(async () => {
    ech.query();
});

function onXmlClick(item: Mailbox) {
    const url = apiUrl(`/mailbox/getPayload`, { id: item.id });
    window.open(url, 'csvExport');
}
function onshowErrorClick(item: Mailbox) {
    alert(item.error);
}
</script>

<template>
    <KtgTable v-model:sort="tableSort" v-model:pageSize="pageSize" :headers="tableHeaders" :data="models"
        ><template #[`item.myactions`]="{ item }">
            <ktg-button @click="onXmlClick(item)"> &lt; /&gt; </ktg-button>
            <ktg-button
                appearance="danger"
                v-if="item.error"
                @click="onshowErrorClick(item)"
                leading-icon="warning"
            ></ktg-button> </template
    ></KtgTable>
</template>

<style scoped></style>
